export default function Marquee({ items, className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`relative overflow-hidden ${className}`}>
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {doubled.map((it, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif text-4xl md:text-6xl text-ivory/90 px-8 md:px-12">{it}</span>
            <span className="text-gold text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
